import React, { useState } from "react";
import "./invoiceshistory.css";
// components imports
import FullPageModal from "../../../../../Components/Modals/FullPageModal/FullPageModal";
import InvoiceTable from "../../../../../Components/BoltTable/BoltTable";
import Tooltip from "../../../../../Components/Tooltip/Tooltip";
// apis imports
import { fetchShipperInvoicesHistoryByID } from "../../../../../services/AdminServices/Users/users.services";
// library imports
import { MdOutlineStickyNote2 } from "react-icons/md";
import CircularProgress from "@mui/material/CircularProgress";
import { convertTime } from "../../../../../helpers/helpers";
import Backdrop from "@mui/material/Backdrop";
import Modal from "@mui/material/Modal";
import { useTranslation } from "react-i18next";

const InvoicesHistory = ({ open, setOpen, User, setSnack }) => {
  const { t } = useTranslation("admin");
  const [payments, setPayments] = useState([]);
  const [actionLoader, setactionLoader] = useState("");

  const getShippersInvoicesHistory = async (page, perPage, filter) => {
    const response = await fetchShipperInvoicesHistoryByID(
      User?.id,
      page,
      perPage,
      filter
    );

    if (!response.error) {
      setPayments(response?.data?.result);
    } else {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("common:messages.somethingWentWrong"),
          severity: "error",
        };
      });
    }
  };

  const columns = [
    {
      id: 1,
      label: t("users.invoiceNumber"),
      render: (row) => <>{row?.invoice_no ?? "-"}</>,
      width: "200px",
    },
    {
      id: 2,
      label: t("users.subTotal"),
      render: (row) => <>{Number(row?.actual_price)?.toFixed(2) ?? "-"}</>,
      width: "200px",
    },
    {
      id: 3,
      label: t("users.taxes"),
      render: (row) => (
        <>
          {row?.tax_details?.length > 0 ? (
            <>
              {row?.tax_details?.map(({ name }, index) => {
                return (
                  <>
                    <span key={index}>
                      {name}
                      {index === 0 ? "" : ","}
                    </span>
                  </>
                );
              })}
            </>
          ) : (
            "-"
          )}
        </>
      ),
      width: "200px",
    },
    {
      id: 4,
      label: t("users.taxTotal"),
      render: (row) => <>{Number(row?.tax_price)?.toFixed(2) ?? "-"}</>,
      width: "200px",
    },
    {
      id: 5,
      label: t("users.total"),
      render: (row) => <>{Number(row?.total_price)?.toFixed(2) ?? "-"}</>,
      width: "200px",
    },
    {
      id: 6,
      label: t("users.createdAt"),
      render: (row) => <>{convertTime(row?.created_at)}</>,
      width: "200px",
    },
    {
      id: 7,
      label: t("users.actions"),
      render: (row) => (
        <div className="table_action__wrap">
          <Tooltip title={t("users.downloadInvoice")}>
            <div className="table_action__btn" onClick={() => downloadPdf(row)}>
              {actionLoader === row?.id ? (
                <CircularProgress size={10} />
              ) : (
                <MdOutlineStickyNote2 size={10} />
              )}
              {t("users.invoiceButton")}
            </div>
          </Tooltip>
        </div>
      ),
      width: "200px",
    },
  ];

  const downloadPdf = async (data) => {
    setactionLoader(data.id);
    const urlfull = data?.file;
    const urlParts = urlfull.split("/");
    const filename = urlParts[urlParts.length - 1];
    try {
      fetch(urlfull, {
        method: "GET",
        headers: {
          "Content-Type": "application/pdf",
        },
      })
        .then((url) => url.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(new Blob([blob]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `${filename}`);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          setactionLoader("");
        });
    } catch (error) {
      setactionLoader("");
    }
  };

  const handleClose = () => {
    setOpen(false);
    setactionLoader("");
  };

  return (
    <>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <div className="prdtable__hist_modal">
          <div
            className="prdtable__hist_modalheading history__product_heading  history__main_heading"
            style={{
              border: "none",
            }}
          >
            {t("users.invoicessHistory")}
          </div>
          <div className="prdtable__hist_modalheading history__product_heading history__sub_heading">
            {open?.username ?? ""} ({open?.business_name ?? ""})
          </div>
          <div className="prdtable__hist_modalcontent history__product_content">
            <InvoiceTable
              tableId="invoiceHistoryTableForAdmin"
              message={t("users.noInvoicesAvailableToDisplay")}
              searchPlaceHolder={t("users.searchInvoices")}
              columns={columns}
              data={payments}
              getAllData={getShippersInvoicesHistory}
              disableAutoResizing={true}
              maxHeight="100%"
            />
          </div>
          <div className=" history__product_footer">
            <div className="history__product_footer_btn" onClick={handleClose}>
              x
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default InvoicesHistory;
